// @ts-ignore
import { findIn, on, removeAttribute } from "@elements/dom-utils";
// @ts-ignore
import { getPrefixedDataSet } from "@elements/data-set-utils";
import { renderTemplate } from "./utils";
export function createOnetrustOverlay(baseElement, options, selectors) {
    let data = getPrefixedDataSet(selectors.dataset, baseElement);
    let button = findIn(selectors.button, baseElement);
    let onChangeListening = false;
    // @ts-ignore
    const originalWrapper = window.OptanonWrapper;
    // @ts-ignore
    if (originalWrapper) {
        // @ts-ignore
        window.OptanonWrapper = () => {
            originalWrapper();
            // @ts-ignore
            if (OnetrustActiveGroups.includes(data.service)) {
                renderTemplate(baseElement, { base: selectors.base, template: selectors.template });
            }
            else {
                if (baseElement.getAttribute('hidden')) {
                    removeAttribute('hidden', baseElement);
                }
            }
            // @ts-ignore
            if (OneTrust && !onChangeListening) {
                onChangeListening = true;
                // @ts-ignore
                OneTrust.OnConsentChanged(() => {
                    // @ts-ignore
                    if (OnetrustActiveGroups.includes(data.service)) {
                        renderTemplate(baseElement, { base: selectors.base, template: selectors.template });
                    }
                    else {
                        if (baseElement.getAttribute('hidden')) {
                            removeAttribute('hidden', baseElement);
                        }
                    }
                });
            }
        };
    }
    if (button) {
        on('click', () => {
            // @ts-ignore
            OneTrust.ToggleInfoDisplay();
        }, button);
    }
}
